//

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { catchError, lastValueFrom } from 'rxjs';
import { HandleError } from 'src/app/utils/network-error-handler';
import { Model_RunnerTask } from 'src/app/app.models';

@Injectable()
export class ConnectorZBEQuickActionsBottomSheetService {

    constructor(private httpClient: HttpClient, private apiService: ApiService) {
    }

    doGetAdmPAliasesAction_BOAdmAlias() {
        return lastValueFrom(this.httpClient.get<any[]>(this.apiService.endPointsBO.doGetAdmPAliasesAction_BOAdmAlias)
        .pipe(catchError(error => HandleError(error))));
    }
    
    doSaveRunnerTasksAction_BOAdmSageLink(_runnerTaskDto : any){
        return lastValueFrom(this.httpClient.post<Model_RunnerTask[]>(this.apiService.endPointsBO.doSaveRunnerTasksAction_BOAdmSageLink, _runnerTaskDto)
        .pipe(catchError(error => HandleError(error))));
    }

}